import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class SystemSettingsService {
  constructor(private http: HttpClient) {}

  public fetchSystemSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_SYSTEM`
    return this.http.get(url, {})
  }

  public updateSystemSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_SYSTEM`
    return this.http.put(url, payload)
  }
}
